module.exports = __webpack_public_path__ + "img/undo-icon.f3736b4d.svg";